module.exports = __webpack_public_path__ + "media/application/images/icons/play-ae03834faa8ccf8791880150983846ff.svg";